import { useMutation } from "@tanstack/react-query";
import { portalApiClient } from "src/api/apiClient";
import { apiUrls } from "src/consts/ApiUrls";
import { useAssignmentByInspectionId } from "../useAssignment";

export default function useDeleteAssignmentMutation() {
  const { invalidate } = useAssignmentByInspectionId();
  const mutation = useMutation({
    mutationFn: async (id: string) => {
      const response = await portalApiClient.delete(
        apiUrls.assignment.byId.url(id)
      );
      invalidate();
      return response?.data;
    },
    onSuccess: () => {
      invalidate();
    },
  });
  return mutation;
}
